import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, Output, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiRequestsService } from '@base/api/api.gateway';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HelpersService, AuthService, UserService } from '@base/shared/services';
import * as moment from 'moment';
import { environment } from '@env/environment';


@Component({
  selector: 'safeprox-report-modal',
  templateUrl: './safeprox-report-modal.component.html',
  styleUrls: [
    './safeprox-report-modal.component.sass',
    '../../../../../modules/daily-logs/submitter/notes/notes.component.sass'
  ],
  entryComponents: [
  ]
})

export class SafeProxReportModal {

  queryParams: any;
  loading: Boolean = false;
  album: any = {};
  sectionId: any;
  reportForm: FormGroup;
  data: any = {};
  displayWarning: Boolean = false;
  warningMessage: String = '';

  private rootContractId = this.accountService.account.contract.contractId;

  currentNote: any;
  readOnly: Boolean = false;
  isMobile: Boolean = false;

  currentDate: Date = new Date();
  endDate: Date = new Date();

  @Input() currentNoteId;

  constructor(
    public activeModal: NgbActiveModal,
    private activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private api: ApiRequestsService,
    private helpers: HelpersService,
    private authService: AuthService,
    private accountService: UserService
  ) { }

  streamOpened() { }
  streamClosed() {

  }
  /** TODO: use note.component */
  async ngOnInit() {

    this.sectionId = this.activeRoute.snapshot.paramMap.get('id');;
    this.queryParams = this.activeRoute.snapshot.queryParams;

    this.bootstrapForm();
  }

  /**
   * Initialize photo form
   */
  private bootstrapForm() {
    const startDate = moment(this.currentDate).subtract(2, 'week').toDate();
    const endDate = moment(this.endDate).toDate();

    this.reportForm = this.formBuilder.group({
      startDate: [
        { value: startDate, disabled: true }, [Validators.required]
      ],
      endDate: [
        { value: endDate, disabled: true }, [Validators.required]
      ]
    });
  }

  dateChange(data) {
    const startDate = moment(this.reportForm.get('startDate').value);
    const endDate = moment(this.reportForm.get('endDate').value);

    const diff = endDate.diff(startDate, 'days');

    if (diff >= 180) {
      this.warningMessage = 'workforce.report.180warning';
      this.displayWarning = true;
      this.resetWarningMessage();
      this.helpers.setFormError(this.reportForm, false);
    }

    if (diff < 0) {
      this.warningMessage = 'Invalid date range';
      this.displayWarning = true;
      this.resetWarningMessage();
      this.helpers.setFormError(this.reportForm, false);
    }

  }

  private resetWarningMessage() {
    setTimeout(() => {
      this.warningMessage = '';
      this.displayWarning = false;
    }, 5000);
  }

  onSubmit({ value }) {
    const params = {
      startDateInclusive: moment(value['startDate']).format('YYYY-MM-DD'),
      endDateInclusive: moment(value['endDate']).format('YYYY-MM-DD')
    };
    const workerId = this.data['workerId'];
    const contractId = this.data['mainContractId'];
    this.loading = true;
    this.api.contracts.runContractSafeProxReport(contractId, workerId, params).toPromise()
      .then((res) => {
        this.download(res.uid);
        this.cancel();
      })
      .catch((error) => {
        this.helpers.errorMessage(error);
        this.loading = false;
      });

  }

  private download(source) {
    if (source) {
      window.open(`${environment.baseUrl}/v2/downloads/file?uid=${source}`, '_blank');
    }

    this.loading = false;
  }

  goBack() {
    this.closeModal();
  }

  /**
   * Cancel note creation / edition
   */
  cancel() {
    this.closeModal({});
  }

  /**
   * Close current Modal
   * @param {[type]} result [description]
   */
  closeModal(result?) {
    this.activeModal.close(result);
  }

}
